import { useState } from 'react'

/* CSS GLOBAL */
import './Global.css'
import 'bootstrap/dist/css/bootstrap.min.css'

/* Components */
import Header from './Components/Header'
import About from './Components/About'
import Services from './Components/Services'
import Contact from './Components/Contact'
import Footer from './Components/Footer'
import Location from './Components/Location'
import ScrollButton from './Components/ScrollButton'
import OtherServices from './Components/OtherServices'
import CarouselSection from './Components/Carousel'
import StartupModal from './Components/StartupModal'

function App() {
  const [showStartupModal, setShowStartupModal] = useState(true)

  return (
    <>
      <StartupModal
        isOpen={showStartupModal}
        onClose={() => setShowStartupModal(false)}
      />
      <Header />
      <main className="app-main">
        <CarouselSection />
        <div id="about"></div>
        <About />
        <div id="services-section"></div>
        <Services />
        <OtherServices />
        <div id="Location-h3"></div>
        <Location />
        <div id="contact-section"></div>
        <Contact />
      </main>
      <ScrollButton />
      <Footer />
    </>
  )
}

export default App
